import teamDefinitionRequests from './team-definition/team-definition'
import checklistDictionaryRequests from './checklist-dictionary/checklist-dictionary'

export default {
  ...checklistDictionaryRequests,
  ...teamDefinitionRequests,
}
